<template>
  <v-container>
    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'LayoutDocumento',
  data: () => ({
    //
  }),
}
</script>

<style>
/*  */
</style>
